import {
  LocationGeographicalCenter,
  LocationFilterInputObject,
  useSiteLocationCenterQuery,
  SiteLocationCenterQueryVariables,
  SiteFilterInputObject,
} from 'graphql-common';
import createSearchFilters from '@lib/utils/createSearchFilters';
import { ApolloError } from '@apollo/client';

type Args = {
  additionalSiteFilters?: object[];
  defaultFilters?: object[];
  searchQuery?: string;
  skip?: boolean;
};

export type UseSectorQueryHookResult = {
  data?: LocationGeographicalCenter;
  error: ApolloError | undefined;
  firstLoading: boolean;
  loading: boolean;
  refetch: () => Promise<unknown>;
};

export default function useSiteLocationCenterQueryHook(
  args: Args,
): UseSectorQueryHookResult {
  const {
    additionalSiteFilters,
    searchQuery,
    skip,
    defaultFilters = [],
  } = args;
  const filters: LocationFilterInputObject[] = [...defaultFilters];
  const variables: SiteLocationCenterQueryVariables = {};
  const siteFilters: SiteFilterInputObject[] = [];
  if (searchQuery) {
    siteFilters.push(
      ...createSearchFilters(searchQuery, [
        { fieldName: 'areasCode' },
        { fieldName: 'areasName' },
        { fieldName: 'code' },
        { fieldName: 'name' },
        { fieldName: 'userFullName' },
        { fieldName: 'sectorName' },
      ]),
    );
  }
  if (additionalSiteFilters?.length) {
    siteFilters.push(...additionalSiteFilters);
  }
  if (siteFilters.length) {
    variables.siteFilters = siteFilters;
  }
  if (filters.length) {
    variables.filters = filters;
  }
  const query = useSiteLocationCenterQuery({
    variables,
    fetchPolicy: 'network-only',
    skip,
  });
  const { data: queryData, refetch, loading, error, previousData } = query;
  const data = queryData || previousData;
  const firstLoading = loading && queryData === undefined;

  return {
    data: data?.data ? { lat: data?.data.lat, lon: data.data.lon } : undefined,
    error,
    firstLoading,
    loading,
    refetch,
  };
}
